<template>
  <div class="serigyHash d-flex mx-2">
    <b-modal v-model="showHashPortal" size="lg" centered header-bg-variant="secondary"
    header-text-variant="light" title="Hash do Portal" hide-footer>
    <div class="d-flex justify-content-between align-items-center">
      <span>{{ hashPortal }}</span>
      <b-button variant="secondary" @click="copiar">
        <font-awesome-icon icon="clipboard" class="mr-2" />
        Copiar
      </b-button>
    </div>
    </b-modal>
    <b-button
      variant="secondary"
      :disabled="isLoadingHash"
      :title="buttonText"
      @click="onButtonClick"
    >
      <b-spinner small v-if="isLoadingHash" class="mr-2" />
      <font-awesome-icon v-else :icon="buttonIcon" class="mr-2" />
      <span class="hashButtonText">{{ buttonText }}</span>
    </b-button>
  </div>
</template>
<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import serigyService from "@/services/administracao/serigyService";

const CompProps = Vue.extend({
  name: "GeradorDeHash",
  components: {},
});

@Component
export default class GeradorDeHash extends mixins(UtilsTS, CompProps) {
  hashPortal: string | null = null;
  isLoadingHash = false;
  showHashPortal = false;

  get buttonIcon(): string {
    if (this.hashPortal) {
      return "eye";
    }
    return "key";
  }
  get buttonText(): string {
    if (this.hashPortal) {
      return "Ver Hash";
    }
    return this.isLoadingHash ? "Gerando..." : "Gerar Hash";
  }

  async mounted(): Promise<void> {
    await this.carregarHashPortal();
  }

  async carregarHashPortal(): Promise<void> {
    try {
      const ug = await serigyService.getUgLogada();
      this.hashPortal = ug.hashPortal || null;
      this.showHashPortal = false;
    } catch (error) {
      console.error("Erro ao carregar hash do portal:", error);
      this.$toast.error("Erro ao carregar hash do portal");
    }
  }

  copiar(): void {
    if (this.hashPortal) {
      navigator.clipboard.writeText(this.hashPortal)
        .then(() => {
          this.$toast.success("Hash copiado para a área de transferência");
        })
        .catch((error) => {
          console.error("Erro ao copiar hash:", error);
          this.$toast.error("Erro ao copiar hash");
        });
    }
  }

  async gerarNovoHash(): Promise<void> {
    try {
      this.isLoadingHash = true;
      const ug = await serigyService.gerarHashUgLogada();
      this.hashPortal = ug.hashPortal;
      this.showHashPortal = true;
      this.$toast.success("Hash do portal gerado com sucesso");
    } catch (error) {
      console.error("Erro ao gerar hash do portal:", error);
      this.$toast.error("Erro ao gerar hash do portal");
    } finally {
      this.isLoadingHash = false;
    }
  }

  onButtonClick(): void {
    if (this.hashPortal) {
      this.toggleShowHash();
    } else {
      this.gerarNovoHash();
    }
  }

  toggleShowHash(): void {
    this.showHashPortal = !this.showHashPortal;
  }
}
</script>
<style scoped>

</style>